module.exports = __webpack_public_path__ + "img/con1.50eb2739.png";